import { StepIconProps, StepIcon } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';

export const StepperStepIcon: React.FC<StepIconProps> = (props) => {
  const { completed } = props;

  if (completed) {
    return <VyIcon icon="CompletedStepIcon" strokeWidth={0} />;
  }

  return <StepIcon {...props} />;
};
